import { Paywall } from '/src/components/Paywall';

import { selectedSiteAtom, useMutation, useNotifications, useFeatureMetric } from '/src/hooks';
import { enableSiteMutation } from '../mutations';

import UfoPNG from '@crazyegginc/hatch/dist/images/illustration-ufo-with-bg-and-objects.png';
import UfoWebP from '@crazyegginc/hatch/dist/images/illustration-ufo-with-bg-and-objects.webp';
import { useAtom } from 'jotai';

export function OptInWall({ mini }) {
  const [selectedSite, setSelectedSite] = useAtom(selectedSiteAtom);
  const { isLoading, mutate } = useMutation(enableSiteMutation);
  const notifications = useNotifications();

  useFeatureMetric('web_analytics_needs_enabled');

  return (
    <Paywall>
      <Paywall.Image
        webp={UfoWebP}
        fallback={UfoPNG}
        width={mini ? '80px' : '185px'}
        className={mini ? '!mb-3 !mt-2' : '!mt-0 !mb-[25px]'}
        alt="UFO"
      />
      <Paywall.Title mini={mini}>Get traffic reporting</Paywall.Title>
      <Paywall.Body>
        Activate Web Analytics to start tracking
        <br />
        website traffic and visitor behavior.
      </Paywall.Body>
      <Paywall.Button
        className={mini ? '!mb-0' : ''}
        onClick={() =>
          mutate(
            {
              siteId: selectedSite.id,
              enable: true,
            },
            {
              onSuccess() {
                setSelectedSite({
                  ...selectedSite,
                  webAnalyticsEnabled: true,
                });
              },
              onError() {
                notifications.error({
                  content: 'Failed to enable analytics.',
                  timeout: 3000,
                  skipHoneybadger: true,
                });
              },
            },
          )
        }
        disabled={isLoading}
      >
        {isLoading ? 'Activating...' : 'Activate Now'}
      </Paywall.Button>
    </Paywall>
  );
}

OptInWall.displayName = 'OptInWall';
